/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { NewsAndEventsFeedComponentEditor } from "cms/components/components/news-events-feed/edit";
import { NewsAndEventsFeedComponentDisplay } from "cms/components/components/news-events-feed/display";
import { getComponentZoneLayout } from "cms/components/components/component";

const NewsAndEventsFeedComponent = (props) => {

    const zoneProps = {
        ...props,
        displayComponent: <NewsAndEventsFeedComponentDisplay />,
        editComponent: <NewsAndEventsFeedComponentEditor />,
    };
    return getComponentZoneLayout(zoneProps);
};

NewsAndEventsFeedComponent.displayName = "NewsAndEventsFeedComponent";
export { NewsAndEventsFeedComponent };
